export class IntegerTranslator {
  from(bean: string): number {
    if (bean === "") {
      return null;
    }
    const parsed = parseInt(bean, 10);
    return isNaN(parsed)
      ? null
      : parsed;
  }
  to(object: number): string {
    // isNaN()はnullが入るとfalse、undefinedが入るとtrueを返す。そのため別途nullチェックを行っている。
    return (object !== null && !isNaN(object))
      ? Math.floor(object).toString()
      : undefined;
  }
}
